export const APP_STORE_URL =
  "https://apps.apple.com/ca/app/govava-ai-gift-finder-ideas/id6739616822";

export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.app.govavaai";
